import * as React from 'react'
import { useEffect } from 'react'
import { useGlobal } from '../global/useGlobal'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { MainStackScreenNames } from '../navigation/MainStack'
import { AuthStackScreenNames } from '../navigation/AuthStack'
import { BaseNavigationProps } from '../navigation/_root'

export const AuthLoadingScreen: NavigationStackScreenComponent<BaseNavigationProps> = ({ navigation }) => {
  const [authToken] = useGlobal('authToken')

  const checkUserToken = () => {
    if (authToken) {
      navigation.navigate(MainStackScreenNames.Dashboard)
    } else {
      navigation.navigate(AuthStackScreenNames.Login)
    }
  }

  useEffect(() => {
    checkUserToken()
  }, [navigation])

  return null
}

AuthLoadingScreen.navigationOptions = {
  headerShown: false,
}
